import $ from 'jquery'
import 'awesomplete'
import { resetSelector } from './selector'
import {Core} from "./core.js";

export class Search {

  constructor () {
    this.$container = $('.archive-search')

    if (this.$container.length === 0) return

    this.isActiveAutocomplete = false
    this.postType = this.$container.data('type')

    if (typeof this.$container.data('autocomplete') !== 'undefined') {
      this.isActiveAutocomplete = true
      this.isLoadAutocomplete = false
    }

    if (typeof search_filter_algo !== 'undefined') {
      this.algo = search_filter_algo
    } else {
      this.algo = false
    }

    this.init()
  }

  init () {
    this.$window = $(window)
    this.$body = $('body')

    this.classInputTextSearch = '#filter-search'

    this.$filterSearch = this.$container.find(this.classInputTextSearch)
    this.$resultsGrid = $('.archive-search-results')
    this.$formSearch = this.$container.find('.archive-search-filter-form')
    this.$resetButton = this.$container.find('#reset-search-filters')
    this.$inputPaged = this.$formSearch.find('input[name="spaged"]')
    this.$countFilters = this.$formSearch.find('#counter-filters')
    this.$reducerFilters = this.$formSearch.find('#reducer-filters')
    this.$filterTags = this.$formSearch.find('.archive-search-filter-tags')

    // Only for page Insights
    this.countActiveFilter = 0
    this.$insightsFlexible = this.$body.find('.insights-flexibles')

    // Only for flexible filters
    this.$flexible = this.$body.find('.advanced-search-filters')

    this.isPreviousBrowser = false
    this.formSearchSubmitTime = 0
    this.urlClean = document.location.protocol + '//' + document.location.host + document.location.pathname

    this.$filterSearch.on('keyup', this.handleKeyupSearch.bind(this))
    this.$formSearch.on('change', 'select', this.handleChangeSelect.bind(this))
    this.$formSearch.on('change submit', this.handleSubmitForm.bind(this))
    this.$formSearch.on('click', '.archive-search-filter-tags .search-tag', this.handleClickTag.bind(this))
    this.$resetButton.on('click', this.handleResetForm.bind(this))
    this.$reducerFilters.on('click', this.handleReducerFilters.bind(this))
    this.$container.on('click', '.archive-search-pagination a', this.handleClickPagination.bind(this))
    this.$window.on('popstate', this.handlePopstate.bind(this))

    // With occupation filter
    this.$filterOccupation = $('#filter-occupation')
    this.$filterFunctionalArea = $('#filter-functional-area')

    if (this.$flexible.length) {
      this.$loader = this.$flexible.find('.spinner')
    } else {
      this.$loader = $('.spinner')
    }

    if (this.algo) {
      setTimeout(this.updateFunctionalAreaToAlgo.bind(this), 150)
    }

    this.updateTags()
    this.refreshUi()
  }

  handlePopstate (e) {
    this.isPreviousBrowser = true
    this.resetFormByParamsUrl()
  }

  handleReducerFilters (e) {
    e.preventDefault()
    this.$formSearch.toggleClass('reduce')
  }

  handleClickTag (e) {
    e.preventDefault()
    let $item = $(e.currentTarget)
    let $select = this.$formSearch.find(`select[name="${$item.data('category')}"]`)

    $select.parent().find(`.selector-option-selected[data-value="${$item.data('value')}"]`).click()

    $item.remove()
  }

  handleChangeSelect (e) {
    this.updateInputPaged(1)
    this.updateTags()

    if (this.algo) {
      if ($(e.currentTarget).attr('name').includes('occupation')) {
        this.updateFunctionalAreaToAlgo()
      }
    }
  }

  handleResetForm (e) {
    e.preventDefault()
    this.$filterSearch.val('')

    this.resetSelectors()
    this.updateInputPaged(1)
    this.updateTags()
    this.ajaxSubmitForm()
  }

  handleClickPagination (e) {
    e.preventDefault()
    this.updateInputPaged($(e.target).data('paged'))
    this.ajaxSubmitForm()
    Core.scrollTo(this.$container)
  }

  handleKeyupSearch (e) {
    let $elt = $(e.target)
    let value = $elt.val()

    if (this.isActiveAutocomplete && !this.isLoadAutocomplete) {
      this.isLoadAutocomplete = true
      this.autocomplete()
    }

    $elt.focus()

    let self = this
    setTimeout(() => {
      if ($elt.val() === value) {
        self.updateInputPaged(1)
        self.ajaxSubmitForm()
      }
      $elt.focus()
    }, 900)
  }

  handleSubmitForm (e) {
    e.preventDefault()

    if ($(e.target).prop('tagName') !== 'INPUT') {
      this.ajaxSubmitForm()
    }
  }

  ajaxSubmitForm () {
    let self = this
    let time = new Date().getTime()

    self.formSearchSubmitTime = time
    self.$resultsGrid.find('.alert').remove()
    self.$resultsGrid.find('.has-error').removeClass('has-error')
    self.$resultsGrid.find('.error').remove()
    self.$loader.show()

    if (self.isPreviousBrowser) {
      this.isPreviousBrowser = false
    } else {
      self.refreshUrl()
    }

    $.ajax({
      url: ajax_url.ajax_url,
      data: self.$formSearch.serialize(),
      type: 'POST',
      dataType: 'json',
      success: function (data) {
        if (time === self.formSearchSubmitTime) {
          self.refreshUi()
          if (data.success) {
            if (typeof data.data.header !== 'undefined') {
              $('.header-search').replaceWith(data.data.header)
            }
            if ((self.$flexible.length ||self.$insightsFlexible.length) && self.countActiveFilter === 0) {
              self.$resultsGrid.html('')
            } else {
              self.$resultsGrid.html(data.data.view)
            }
          } else {
            if (data.data) {
              if ((typeof data.data) === 'string') {
                self.$resultsGrid.prepend('<div class="alert alert-warning" style="margin: 20px 0;">' + data.data + '</div>')
              }
            }
          }
          self.$loader.hide()
        }
      },
      complete: function () {
        if (time === self.formSearchSubmitTime) {
          self.$loader.hide()
        }
      }
    })
  }

  refreshUi () {
    this.countActiveFilter = 0;

    this.$formSearch.find('select').each((i, elt) => {
      let $elt = $(elt)
      if ($elt.val() !== '-1' && $elt.val().length > 0) {
        if ($elt.val().length > 1) {
          this.countActiveFilter += $elt.val().length
        } else {
          this.countActiveFilter++
        }
      }
    })

    if (this.$filterSearch.length && this.$filterSearch.val() !== '-1' && this.$filterSearch.val().length > 0) {
      this.countActiveFilter++
    }

    if (this.countActiveFilter > 0) {
      this.$resetButton.addClass('active')

      if (this.countActiveFilter === 1) {
        this.$countFilters.text(this.$countFilters.data('single'))
      } else {
        this.$countFilters.text(this.$countFilters.data('multiple').replace('%s%', this.countActiveFilter))
      }

      if (this.$insightsFlexible.length) {
        this.$insightsFlexible.hide()
      }

      if (this.$flexible.length) {
        this.$flexible.nextAll('section').each((i, elt) => {
          if ($(elt).find('form').length === 0) {
            $(elt).hide()
          }
        })
      }
    } else {
      this.$resetButton.removeClass('active')
      this.$countFilters.text(this.$countFilters.data('none'))

      if (this.$insightsFlexible.length) {
        this.$insightsFlexible.show()
      }

      if (this.$flexible.length) {
        this.$flexible.nextAll('section').each((i, elt) => {
          if ($(elt).find('form').length === 0) {
            $(elt).show()
          }
        })
      }
    }
  }

  autocomplete () {
    let self = this
    let data = {
      action: 'vah_search_autocomplete',
      post_type: this.postType,
      page_id: this.$formSearch.find('input[name="page_id"]').val()
    }

    if (this.$insightsFlexible.length) {
      data.action = 'vah_search_autocomplete_multiple'
    } else {
      data.action = 'vah_search_autocomplete'
    }

    if (this.postType === 'partner') {
      data.partner_type = self.$formSearch.data('partner-type')
    }

    $.ajax({
      url: ajax_url.ajax_url,
      data: data,
      type: 'POST',
      dataType: 'json',
      success: function (data) {
        if (data.success) {
          let autocomplete = new Awesomplete(document.querySelector(self.classInputTextSearch), { list: data.data.list })

          self.$filterSearch.on('awesomplete-selectcomplete', function () {
            self.resetSelectors()
            self.ajaxSubmitForm()
          })
          self.$filterSearch.on('focus', function() {
            autocomplete.evaluate();
          });
        }
      },
      completed: function () {
        self.isLoadAutocomplete = false
      }
    })
  }

  refreshUrl () {
    let urlClean = this.urlClean
    let urlParams = this.createParamsUrlWithFilters()

    if (urlParams !== '') {
      urlClean += '?' + urlParams
    }
    this.replaceUrl(urlClean)
  }

  createParamsUrlWithFilters () {
    let tabParamsUrl = this.$formSearch.serializeArray()
    let tabParams = {}

    $.each(tabParamsUrl, (index, val) => {
      let category = val.name.replace('[]', '')
      let value = val.value

      if (category === 'action'
        || category === 'page_id'
        || category === 'author_page'
        || value === 'false'
        || value === '-1'
        || (category === 'txt' && value === '')
        || (category === 'spaged' && value === '1')
      ) {
        return ''
      } else {
        if (tabParams[category] === undefined) {
          tabParams[category] = value
        } else {
          tabParams[category] += `-${value}`
        }
      }
    })
    return this.paramsTabToParamsUrl(tabParams)
  }

  getUrlParams () {
    return window.location.search.substr(1)
  }

  replaceUrl (new_url) {
    window.history.pushState({}, document.title, new_url)
  }

  paramsTabToParamsUrl (paramTab) {
    let urlParams = ''

    $.each(paramTab, function (category, data) {
      if (category !== 'action' && data !== '-1') {
        urlParams += category + '=' + data + '&'
      }
    })
    if (urlParams.length > 2) urlParams = urlParams.substring(0, urlParams.length - 1)
    return urlParams
  }

  updateInputPaged (number) {
    this.$inputPaged.val(number)
  }

  updateTags () {
    this.$filterTags.html('')
    let selectArray = this.$formSearch.find('select')

    selectArray.each((index, select) => {
      let $select = $(select)

      $select.find(':selected').each((index, option) => {
        let $option = $(option)

        if ($option.attr('value') !== '-1') {
          this.$filterTags.append(`<div class="search-tag" data-category="${$select.attr('name')}" data-value="${$option.attr('value')}"><i class="icon icon-close_1"></i>${$option.text()}</div>`)
        }
      })
    })
  }

  resetFormByParamsUrl () {
    let self = this
    let params_url = this.getUrlParams().split('&')

    this.$filterOccupation.val('-1')
    this.$filterSearch.val('')
    this.$inputPaged.val('1')

    params_url.map(function (param_string) {
      let paramTab = param_string.split('=', 2)
      let $filter = self.$formSearch.find('[name="' + paramTab[0] + '"]')

      if ($filter.length) {
        $filter.val(paramTab[1])

        if ($filter.prop('tagName') === 'SELECT') {
          let $parent = $filter.parent()
          let $option_selected = $filter.find('option:selected')

          $parent.find('.select-selected').text($option_selected.text())
          $parent.find('.same-as-selected').removeClass('same-as-selected')
          $parent.find('.select-items').find(`div:nth-child(${$option_selected.index()})`).addClass('same-as-selected')
        }
      }
    })
    if (this.algo) {
      this.updateFunctionalAreaToAlgo()
    }
    this.ajaxSubmitForm()
  }

  updateFunctionalAreaToAlgo () {
    let choice = this.$filterOccupation.val()
    let $selectFunctionalArea = this.$filterFunctionalArea
    let optionsVisible = []

    this.updateInputPaged(1)
    this.$filterFunctionalArea.prop('disabled', false)

    if (Array.isArray(choice)) {
      $.each(choice, (i, value) => {
        if (this.algo.hasOwnProperty(value)) {
          $selectFunctionalArea.find('option').each((i, option) => {
            let $option = $(option)
            let optionValue = $option.attr('value')

            if (!optionsVisible.includes(optionValue) && (this.algo[value].includes(Number(optionValue)) || optionValue === '-1')) {
              optionsVisible.push(optionValue)
            }
          })
        }
      })
    } else {
      if (this.algo.hasOwnProperty(choice)) {
        $selectFunctionalArea.find('option').each((i, option) => {
          let $option = $(option)
          let optionValue = $option.attr('value')

          if (this.algo[choice].includes(Number(optionValue)) || optionValue === '-1') {
            optionsVisible.push(optionValue)
          }
        })
      }
    }

    if (optionsVisible.length !== 0) {
      $selectFunctionalArea.find('option').each((i, option) => {
        let $option = $(option)
        let optionValue = $option.attr('value')
        let $optionFakeSelect = $selectFunctionalArea.parent().find(`[data-value="${optionValue}"]`)

        if (optionsVisible.includes(optionValue) || optionValue === '-1') {
          $optionFakeSelect.removeClass('hide')
        } else {
          $optionFakeSelect.addClass('hide')
        }
      })
    }

    if (this.$filterOccupation.val() == '-1' || this.$filterOccupation.val() == undefined) {
      this.$filterFunctionalArea.prop('disabled', 'disabled')
      this.$filterFunctionalArea.val('-1')
    }
  }

  resetSelectors () {
    this.$formSearch.find('.selector').each(function (index, select) {
      resetSelector($(select))
    })
  }
}
